import { FC, useCallback, useState } from 'react'

import { MUIButton } from 'components/common/MUIButton'
import { MUIInputField } from 'components/common/MUIInputField'
import Modal from 'components/common/Modals/Modal/Modal'
import { Stack } from '@mui/material'
import { SystemMessage } from 'components/common/SystemMessage'
import styles from './WorkspaceActionPopup.module.sass'
import { useTranslation } from 'react-i18next'

interface Props {
  isOpen: boolean
  workspaceName: string
  title: string
  warningTitle: string
  warningDescription: string
  inputLabel: string
  isPending: boolean
  onClose: () => void
  onConfirm: () => void
}

export const WorkspaceActionPopup: FC<Props> = ({
  isOpen,
  workspaceName,
  title,
  warningTitle,
  warningDescription,
  inputLabel,
  isPending,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation(['common'])

  const [inputValue, setInputValue] = useState('')

  const isConfirmDisabled = inputValue !== workspaceName || isPending

  const resetAndClose = useCallback(() => {
    setInputValue('')
    onClose()
  }, [onClose])

  return (
    <Modal
      isOpen={isOpen}
      modalContentClassName={styles.modalContent}
      onClickOutside={resetAndClose}
      onClose={resetAndClose}
      title={title}
      footerContent={
        <Stack direction="row" justifyContent="flex-end" gap={1}>

          <MUIButton
            type="secondaryBorder"
            disabled={isPending}
            onClick={resetAndClose}
          >
            {t('common:Cancel')}
          </MUIButton>

          <MUIButton
            disabled={isConfirmDisabled}
            isLoading={isPending}
            onClick={onConfirm}
          >
            {t('common:Confirm')}
          </MUIButton>

        </Stack>
      }
    >
      <div className={styles.inside}>

        <SystemMessage
          variant="error"
          title={warningTitle}
          message={warningDescription}
          sx={{ marginBottom: '1.6rem' }}
        />

        <MUIInputField
          label={inputLabel}
          value={inputValue}
          disabled={isPending}
          onChange={(e) => setInputValue(e.target.value)}
        />

      </div>
    </Modal>
  )
}
